var HttpActionResult = /** @class */ (function () {
    function HttpActionResult(request, promise) {
        this.request = request;
        this.promise = promise;
    }
    HttpActionResult.prototype.getPromise = function () {
        return this.promise;
    };
    HttpActionResult.prototype.getRequest = function () {
        return this.request;
    };
    HttpActionResult.prototype.then = function (onfulfilled, onrejected) {
        return this.promise.then(onfulfilled, onrejected);
    };
    HttpActionResult.prototype.catch = function (onrejected) {
        return this.promise.catch(onrejected);
    };
    HttpActionResult.prototype.finally = function (onfinally) {
        return this.promise.finally(onfinally);
    };
    return HttpActionResult;
}());
export { HttpActionResult };
//# sourceMappingURL=http_action_result.js.map